module.exports = "/assets/33caf08b276bbca55379a0a1b8e62d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LJ.png
// module id = 2705
// module chunks = 0